module.exports = __webpack_public_path__ + "img/idea_text2.aa6dc08d.png";